export const KIEU_GIAO_DICH = [
    { value: "", label: "Tất cả" },
    { value: "LN", label: "Tín chấp" },
    { value: "LH", label: "Trả góp" },
    { value: "CĐ", label: "Cầm đồ" },
    { value: "NV", label: "Huy động vốn" },
    { value: "HĐ", label: "Thu/Chi hợp đồng" },
    { value: "NL", label: "Thu/Chi ngoài lề" },
    { value: "GV", label: "Góp vốn" },
    { value: "RV", label: "Rút vốn" },
    { value: "MB", label: "Mua bán" }
];

export const LOAI_GIAO_DICH = [
    { value: "0", label: "Tất cả" },
    { value: "1", label: "Kỳ lãi" },
    { value: "11", label: "Tất toán" },
    { value: "17", label: "Trả bớt gốc" },
    { value: "21", label: "Vay thêm" },
    { value: "2", label: "Chi cho vay" },
    { value: "4", label: "Thu huy động vốn" },
    { value: "24", label: "Thu phí khác" },
    { value: "16", label: "Thanh lý tài sản" },
    { value: "70", label: "Đổi lãi suất" }
];